export const StatusMainPalette: any = {
    1: '#28AEF0',
    2: '#28AEF0',
    3: '#28AEF0',
    4: '#28AEF0',
    5: '#43C464',
    6: '#43C464',
    7: '#FF6157',
    8: '#DE35C1',
    9: '#FF841F',
    10: '#7F5AF2',
    11: '#7C848F',
    12: '#7C848F',
}

export const StatusMainBorderPalette: any = {
    1: '#0CA0E9',
    2: '#0CA0E9',
    3: '#0CA0E9',
    4: '#0CA0E9',
    5: '#39B458',
    6: '#39B458',
    7: '#E8493F',
    8: '#C926AD',
    9: '#EC720E',
    10: '#6E45ED',
    11: '#6F7884',
    12: '#6F7884',
}